export enum ErrorType {
    console,alret,dialog,message
}



// WEBPACK FOOTER //
// ./src/app/error/error-type.enum.ts